import * as React from "react";
import { MouthType, PhotoSet, PhotoSetStatus } from "../../troubleshoot/ReportTroubleshoot";
import PhotoSetStatusViewer from "./PhotoSetStatusViewer";
import { dateWithOptionalTime } from "../utils/date";
import VerticalDropdown from "./vertical-dropdown/VerticalDropdown";

interface ScanPackageViewerProps {
  mouthType: MouthType;
  photoSet: PhotoSet;
  displayAllRejectionCauses: boolean;
}

export default class ScanPackageViewer extends React.PureComponent<ScanPackageViewerProps> {
  render() {
    const photosAvailable = !!this.props.photoSet.photos.length;
    const customButton = (
      <div className={"h-flex space-between align-center" + (photosAvailable ? " clickable" : "")}>
        <div>
          <div>{i18n[getI18nMouthType(this.props.mouthType)]}</div>
          {this.props.photoSet.date && (
            <div className="small">
              {
                i18n[
                  getI18nStatus(
                    this.props.photoSet.status === PhotoSetStatus.REJECTED
                      ? PhotoSetStatus.REJECTED
                      : PhotoSetStatus.RECEIVED
                  )
                ]
              }
              {dateWithOptionalTime(this.props.photoSet.date)}
            </div>
          )}
          <PhotoSetStatusViewer
            status={this.props.photoSet.status}
            className="small"
            detail={this.props.photoSet.detail}
            displayAllRejectionCauses={this.props.displayAllRejectionCauses}
          />
        </div>
        <div className="h-flex align-center with-margins">
          {photosAvailable && (
            <div className="text-action">
              <i className="ic_chevron_down" />
            </div>
          )}
        </div>
      </div>)
    return (
      <VerticalDropdown
        customButton={customButton}
        containerClassName={'scan-package-viewer'}
      >
        {photosAvailable && (
        <div className="photo-grid">
          {this.props.photoSet.photos.map((p) => (
            <img key={p.uid} src={p.href} alt="photo" />
          ))}
        </div>)}
      </VerticalDropdown>
    );
  }
}

const getI18nMouthType = (mouthType: MouthType) => {
  switch (mouthType) {
    case MouthType.CLOSED:
      return "MouthType.Closed";
    case MouthType.SLIGHTLY_OPENED:
      return "MouthType.SlightlyOpened";
    case MouthType.OPENED:
      return "MouthType.Opened";
  }
};

const getI18nStatus = (status: PhotoSetStatus) => {
  switch (status) {
    case PhotoSetStatus.RECEIVED:
      return "PhotoSet.Status.Received";
    case PhotoSetStatus.REJECTED:
      return "PhotoSet.Status.Rejected";
  }
};
